var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    ref: "trigger"
  }, [_vm._t("default"), _vm._v(" "), _c('transition', {
    attrs: {
      "name": _vm.effect
    }
  }, [(_vm.show) ? _c('div', {
    ref: "popover",
    class: ['popover', _vm.placement]
  }, [_c('div', {
    staticClass: "arrow"
  }), _vm._v(" "), (_vm.title) ? _c('h3', {
    staticClass: "popover-title"
  }, [_vm._t("title", [_vm._v(_vm._s(_vm.title))])], 2) : _vm._e(), _vm._v(" "), (_vm.content) ? _c('div', {
    staticClass: "popover-content"
  }, [_vm._t("content", [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.content)
    }
  }), _vm._v(" "), _c('hr', {
    staticStyle: {
      "margin": "10px 0px 15px 0px"
    }
  }), _vm._v(" "), _c('input-w', {
    attrs: {
      "validation": _vm.validation,
      "validateOnValueChange": true
    },
    on: {
      "validateResult": _vm.checkValidateResult
    },
    model: {
      value: (_vm.dataModel),
      callback: function($$v) {
        _vm.dataModel = $$v
      },
      expression: "dataModel"
    }
  }, [_c('datepicker', {
    staticStyle: {
      "padding": "0px",
      "color": "black"
    },
    attrs: {
      "full-month-name": true,
      "clear-button": true,
      "placeholder": _vm.placeholder,
      "format": "dd / MM / yyyy",
      "language": _vm.$root.lang.lang
    },
    model: {
      value: (_vm.dataModel),
      callback: function($$v) {
        _vm.dataModel = $$v
      },
      expression: "dataModel"
    }
  })], 1)])], 2) : _vm._e(), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn btn-danger btn-sm",
    staticStyle: {
      "float": "left",
      "margin": "5px"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary-default btn-sm",
    staticStyle: {
      "float": "right",
      "margin": "5px"
    },
    attrs: {
      "disabled": _vm.invalid
    },
    on: {
      "click": _vm.apply
    }
  }, [_vm._v("Apply")])])]) : _vm._e()])], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ffe72b92","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dynamic/popoverWrapper/DateModifier.vue
// module id = 1570
// module chunks = 1